import { Reveal } from "@/components/Reveal";
import { PrimaryCTA } from "@/components/CTA";
import { CircleScribble } from "@/components/Annotation";
import { LINKS } from "@/config/links";
import { useLang } from "@/i18n";

/**
 * Dedicated promotional banner for the Presentation Readiness Check.
 * Sits between "Client story + video" and "Coaching plan". Green (ink)
 * background, single focused CTA — this is the one spot on the page
 * where the diagnostic itself is allowed to be the primary action,
 * since there is no competing consultation CTA inside this section.
 */
export const ReadinessCheckBanner = () => {
  const { t } = useLang();
  return (
    <section className="relative z-10 py-16 md:py-20 bg-ink text-paper overflow-hidden" data-testid="readiness-banner-section">
      <div className="max-w-[1000px] mx-auto px-5 md:px-10 text-center">
        <Reveal>
          <h2 className="font-serif text-3xl md:text-5xl leading-[1.05] tracking-tight mb-4">
            <span className="relative inline-block">
              {t("landing.readiness_banner_title")}
              <CircleScribble className="absolute -left-4 -top-3 w-[115%] h-[160%]" delay={0.3} />
            </span>
          </h2>
          <p className="font-body text-paper/70 max-w-xl mx-auto mb-8 leading-relaxed">
            {t("landing.readiness_banner_description")}
          </p>
          <PrimaryCTA href={LINKS.diagnostic} testId="readiness-banner-cta" location="readiness_banner" targetAssetId="next_presentation_readiness">
            {t("landing.readiness_banner_cta")}
          </PrimaryCTA>
        </Reveal>
      </div>
    </section>
  );
};
